import { MapPin, ArrowLeft, ArrowRight, Package } from "lucide-react";
import "../../../css/OnRoad.css";

export default function StateTransitionButtons({
    onLlegadaDestino,
    onVolverEnRuta,
    onVolverACargue,
    onVolverEnRutaDesdeCargue,
    estadoOperativo = "CARGUE",
    mostrarBotonVolverCargue = false,
    mostrarBotonVolverEnRutaDesdeCargue = false,
    mostrarBotonVolverRuta = false
}) {
    const handleLlegadaDestino = () => {
        onLlegadaDestino?.();
    };

    const handleVolverEnRuta = () => {
        onVolverEnRuta?.();
    };

    const handleVolverEnRutaDesdeCargue = () => {
        onVolverEnRutaDesdeCargue?.();
    };

    const handleVolverACargue = () => {
        onVolverACargue?.();
    };

    // Función para manejar eventos de teclado
    const createKeyHandler = (callback) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            callback();
        }
    };

    // Función para prevenir propagación en botones
    const createClickHandler = (callback) => (e) => {
        e.stopPropagation();
        callback();
    };

    // Determinar si mostrar el botón "Llegué a mi Destino"
    const mostrarBotonLlegada = estadoOperativo === "EN RUTA";

    // Si no hay ningún botón que mostrar, no renderizar nada
    const hayBotonesVisibles = mostrarBotonVolverCargue || 
                               mostrarBotonVolverEnRutaDesdeCargue || 
                               mostrarBotonLlegada || 
                               mostrarBotonVolverRuta;

    if (!hayBotonesVisibles) {
        return null;
    }

    return (
        <div className="state-transition-section">
            {/* Botón "Volver a Cargue" - Visible en EN_RUTA cuando hay grupos pendientes */}
            {mostrarBotonVolverCargue && (
                <div 
                    className="action-card action-card-clickeable volver-cargue-card"
                    onClick={handleVolverACargue}
                    role="button"
                    tabIndex={0}
                    onKeyDown={createKeyHandler(handleVolverACargue)}
                >
                    <div className="action-header">
                        <div className="action-icon volver-cargue">
                            <Package size={16} />
                        </div>
                        <div className="action-info">
                            <h6 className="action-title">Volver a Cargue</h6>
                            <p className="action-subtitle">Grupos pendientes de reportar</p>
                        </div>
                        <button 
                            className="action-btn outline-volver-cargue" 
                            onClick={createClickHandler(handleVolverACargue)}
                        >
                            Volver
                        </button>
                    </div>
                </div>
            )}
            {/* Botón "Volver a En Ruta" desde CARGUE - Visible cuando hay grupos completados Y pendientes */}
            {mostrarBotonVolverEnRutaDesdeCargue && (
                <div 
                    className="action-card action-card-clickeable volver-ruta-card"
                    onClick={handleVolverEnRutaDesdeCargue}
                    role="button"
                    tabIndex={0}
                    onKeyDown={createKeyHandler(handleVolverEnRutaDesdeCargue)}
                >
                    <div className="action-header">
                        <div className="action-icon volver-ruta">
                            <ArrowRight size={16} />
                        </div>
                        <div className="action-info">
                            <h6 className="action-title">Volver a En Ruta</h6>
                            <p className="action-subtitle">Grupos completados en cargue</p>
                        </div>
                        <button 
                            className="action-btn outline-warning" 
                            onClick={createClickHandler(handleVolverEnRutaDesdeCargue)}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            )}
            {/* Botón "Llegué al Destino" - Solo visible en EN_RUTA */}
            {mostrarBotonLlegada && (
                <div 
                    className="action-card action-card-clickeable llegada-destino-card"
                    onClick={handleLlegadaDestino}
                    role="button"
                    tabIndex={0}
                    onKeyDown={createKeyHandler(handleLlegadaDestino)}
                >
                    <div className="action-header">
                        <div className="action-icon llegada">
                            <MapPin size={16} />
                        </div>
                        <div className="action-info">
                            <h6 className="action-title">Llegué al Destino</h6>
                            <p className="action-subtitle">Notificar llegada al punto de descargue</p>
                        </div>
                        <button 
                            className="action-btn outline-success-green" 
                            onClick={createClickHandler(handleLlegadaDestino)}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            )}

            {/* Botón "Volver a En Ruta" - Solo visible en DESCARGUE */}
            {mostrarBotonVolverRuta && (
                <div 
                    className="action-card action-card-clickeable volver-ruta-card"
                    onClick={handleVolverEnRuta}
                    role="button"
                    tabIndex={0}
                    onKeyDown={createKeyHandler(handleVolverEnRuta)}
                >
                    <div className="action-header">
                        <div className="action-icon volver-ruta">
                            <ArrowLeft size={16} />
                        </div>
                        <div className="action-info">
                            <h6 className="action-title">Volver a Ruta</h6>
                            <p className="action-subtitle">Regresar al estado en tránsito</p>
                        </div>
                        <button 
                            className="action-btn outline-warning" 
                            onClick={createClickHandler(handleVolverEnRuta)}
                        >
                            Volver
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
}